
import { useState, useEffect,useRef } from 'react'
export default function useActive (time) {
    // const [active, setActive] = useState(false)
    // const timer= useRef()
    // const [events, setEvents] = useState(['keypress', 'mousemove', 'touchmove', 'click', 'scroll'])
    const [isActive, setIsActive] = useState(!document.hidden)
    const onTabChange = () => setIsActive(!document.hidden)

    useEffect(() => {
        // const handleEvent = () => {
        //     setActive(true)
        //     if (timer.current) {
        //         window.clearTimeout(timer.current)
        //     }
        //     timer.current = window.setTimeout(() => {
        //         setActive(false)
        //     }, time)
        // }

        // events.forEach((event) => document.addEventListener(event, handleEvent))

        // return () => {
        //     events.forEach((event) => document.removeEventListener(event, handleEvent))
        // }
        document.addEventListener('visibilitychange', onTabChange, false)

        return () => {
            document.removeEventListener('visibilitychange', onTabChange)
        }
    }, [])

    return isActive
}